import { callApi } from './common'
import config from '@/config'

const API_BASE = config.service.platform === 'azure' ? 'azure_' : ''

function monthly(accountId, month, params) {
  if (month) {
    return callApi(
      `billing/${API_BASE}usage_monthly/${accountId}/${month.replace('-', '')}`,
      params,
      'get'
    )
  }
  return callApi(`billing/usage_monthly/${accountId}`, params, 'get')
}

function monthlyByPeriod(accountId, month, period = 1) {
  return callApi(
    `billing/${API_BASE}usage_monthly/${accountId}/months/${month.replace(
      /-/g,
      ''
    )}/${period}`
  )
}

function daily(accountId, startDate, endDate, params) {
  return callApi(
    `billing/${API_BASE}usage_daily/${accountId}/${startDate.replace(
      /-/g,
      ''
    )}/${endDate.replace(/-/g, '')}`,
    params,
    'get'
  )
}

async function dailyByMonths(accountId, month, period, params) {
  return await callApi(
    `billing/${API_BASE}usage_daily/${accountId}/months/${month.replace(
      /-/g,
      ''
    )}/${period}`,
    params,
    'get'
  )
}

function dailyFromBq(params) {
  return callApi(`billing/${API_BASE}usage_daily/${params.id}`, params, 'get')
}

function usageDaily(accountId, params) {
  return callApi(
    `billing/${API_BASE}usage_daily/${accountId}/raws`,
    params,
    'get'
  )
}

function usageDailyCount(accountId, params) {
  return callApi(
    `billing/${API_BASE}usage_daily/${accountId}/raws/count`,
    params,
    'get'
  )
}

function commitment(accountId, params) {
  return callApi(
    `billing/${API_BASE}usage_daily/${accountId}/commitment`,
    params,
    'get'
  )
}

function commitmentFilters(accountId, params) {
  return callApi(
    `billing/${API_BASE}usage_daily/${accountId}/commitment/filters`,
    params,
    'get'
  )
}

export default {
  monthly,
  monthlyByPeriod,
  daily,
  dailyByMonths,
  dailyFromBq,
  usageDaily,
  usageDailyCount,
  commitment,
  commitmentFilters,
}
